module.exports = __webpack_public_path__ + "static/media/google-icon.d3708073.svg";